function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M15.122 9.6749C14.4524 8.89295 14.1481 8.21531 14.1481 7.06407V6.67263C14.1481 5.17242 13.8028 4.20582 13.0521 3.23922C11.8951 1.73809 9.94727 0.833344 8.04046 0.833344H7.95938C6.09266 0.833344 4.20589 1.69654 3.02883 3.13675C2.23714 4.12273 1.85177 5.13087 1.85177 6.67263V7.06407C1.85177 8.21531 1.56752 8.89295 0.877866 9.6749C0.370417 10.251 0.208252 10.9914 0.208252 11.7927C0.208252 12.595 0.471542 13.3548 0.999945 13.9724C1.6896 14.7128 2.6635 15.1855 3.65836 15.2677C5.09871 15.432 6.53907 15.4939 8.00037 15.4939C9.46077 15.4939 10.9011 15.3905 12.3424 15.2677C13.3363 15.1855 14.3102 14.7128 14.9999 13.9724C15.5274 13.3548 15.7916 12.595 15.7916 11.7927C15.7916 10.9914 15.6294 10.251 15.122 9.6749Z",
  fill: "#F0F0F5"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M9.84112 16.626C9.38286 16.5281 6.59053 16.5281 6.13227 16.626C5.74053 16.7165 5.31689 16.927 5.31689 17.3886C5.33967 17.8289 5.59749 18.2176 5.95462 18.4641L5.95371 18.465C6.41561 18.8251 6.95768 19.054 7.52525 19.1362C7.82772 19.1778 8.13565 19.1759 8.44905 19.1362C9.01571 19.054 9.55778 18.8251 10.0197 18.465L10.0188 18.4641C10.3759 18.2176 10.6337 17.8289 10.6565 17.3886C10.6565 16.927 10.2329 16.7165 9.84112 16.626Z",
  fill: "#878794"
});

function SvgBell(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.c9265e2f.svg";
export { ForwardRef as ReactComponent };